import { combineReducers } from 'redux';

import { intlReducer } from '../components/IntlRedux';

import ModulesReducers from '../modules/reducers';

// Use inferred return type for making correctly Redux types
export default combineReducers({
  ...ModulesReducers,
  intl: intlReducer,
});
